import React, { useState, useMemo, useCallback } from "react";
import { Plus, Clock, X, Edit, Trash2, RefreshCcw } from "lucide-react";
import AddTasksAll from "./AddTasksAll";
import Loading from "../Loading";
import SearchBar from "../SearchBar";
import taskApi from "../../api/taskApi";
import { useSelector } from "react-redux";

const TasksTabAll = ({
  selectedClientData,
  getStatusColor,
  getPriorityColor,
  onRefreshAccounts,
  navigate,
errors,
  heading,
  allTasks,
  type,
  workflowDropdown,
  formData, 
  setFormData,
  handleSubmit,
  isLoader,
  showCreateTask, 
  setShowCreateTask,
  handleDeleteTask,
  taskId,
  setTaskId,
  attachments,
  setAttachments,
  comments,
  setComments,
  loading
}) => {
  const [viewTask, setViewTask] = useState(null);
  const [filters, setFilters] = useState({
    workflowName: "all",
    assignee: "all",
    priority: "all",
    status: "all",
  });
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc", // asc | desc
  });

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      }
      return { key, direction: "asc" };
    });
  };


const [searchResultTasks, setSearchResultTasks] = useState(null);
const [isSearching, setIsSearching] = useState(false);
  const token = useSelector((state) => state.auth.access_token);

const handleSearchApi = useCallback(async (query) => {
  if (!query || query.trim().length < 3) {
    setSearchResultTasks(null);
    setIsSearching(false);
    return;
  }

  setIsSearching(true);
  try {
    // Replace with your actual API call
    const res = await taskApi.searchTask(query, token);
    setSearchResultTasks(res.data || []);
  } catch (e) {
    console.error("Task search failed:", e);
    setSearchResultTasks([]);
  } finally {
    setIsSearching(false);
  }
}, [token]);


const filteredTasks = useMemo(() => {
  const baseTasks = searchResultTasks !== null ? searchResultTasks : (allTasks || []);
  
  let tasks = [...baseTasks];

  if (filters.assignee !== "all") {
    tasks = tasks.filter((task) => task?.assignedTo?.fullName === filters.assignee);
  }
  if (filters.priority !== "all") {
    tasks = tasks.filter((task) => task.priority === filters.priority);
  }
  if (filters.workflowName !== "all") {
    tasks = tasks.filter((task) => task.workflowName === filters.workflowName);
  }
  if (filters.status !== "all") {
    tasks = tasks.filter((task) => task.status === filters.status);
  }

  return tasks.sort((a, b) => new Date(b.dueDate) - new Date(a.dueDate));
}, [allTasks, searchResultTasks, filters]);

  const assignees = [
    ...new Set(
      allTasks
        ?.map((t) => t?.assignedTo?.fullName)
        .filter(Boolean)
    ),
  ];
  const workflows = [
    ...new Set(
      allTasks
        ?.map((t) => t?.workflowName)
        .filter(Boolean)
    ),
  ];
  const priorities = [
    ...new Set(
      allTasks?.map((t) => t?.priority).filter(Boolean)
    ),
  ];
  const statuses = [
    ...new Set(
      allTasks?.map((t) => t?.status).filter(Boolean)
    ),
  ];

  const formatText = (text = "") =>
    text
        .toLowerCase()
        .split("_")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
  const isOverdue = (dueDate, status) => {
      if (!dueDate) return false;
      return (
        new Date(dueDate) < new Date() &&
        !["COMPLETED", "DEFERRED"].includes(status)
      );
    };

    const getValueByPath = (obj, path) =>
      path.split(".").reduce((acc, key) => acc?.[key], obj);


    const sortedTasks = useMemo(() => {
      if (!sortConfig.key) return filteredTasks;

      return [...filteredTasks].sort((a, b) => {
        const aVal = getValueByPath(a, sortConfig.key);
        const bVal = getValueByPath(b, sortConfig.key);

        if (!aVal) return 1;
        if (!bVal) return -1;

        if (typeof aVal === "string") {
          return sortConfig.direction === "asc"
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }

        return sortConfig.direction === "asc"
          ? aVal > bVal ? 1 : -1
          : aVal < bVal ? 1 : -1;
      });
    }, [filteredTasks, sortConfig]);


  const SortIcon = ({ column }) => {
    const isActive = sortConfig.key === column;

    return (
      <span className="inline-flex flex-col ml-1 text-[9px] leading-none">
        <span
          className={
            isActive && sortConfig.direction === "asc"
              ? "text-gray-900"
              : "text-gray-300"
          }
        >
          ▲
        </span>
        <span
          className={
            isActive && sortConfig.direction === "desc"
              ? "text-gray-900"
              : "text-gray-300"
          }
        >
          ▼
        </span>
      </span>
    );
  };


  if (loading) {
        return (
            
                <Loading />
        );
    }

  return (
    <div className="space-y-3">
      {(!taskId && !showCreateTask) &&
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-2 py-2">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <h3 className="text-lg font-bold text-slate-700">{heading}</h3>
          <button
            onClick={() => setShowCreateTask(true)}
            className="bg-primary text-white px-3 py-1 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2 w-full sm:w-auto"
          >
            <Plus className="h-4 w-4" />
            <span>Add Task</span>
          </button>
        </div>
        
        {allTasks?.length !== 0 ?
        <div className={`grid grid-cols-1 ${type === "workflow" ? "sm:grid-cols-6" : "sm:grid-cols-5"} gap-3 mt-1`}>
          {assignees.length !==0 ?
          <select
            className="border rounded-lg px-3 py-1 text-sm"
            value={filters.assignee}
            onChange={(e) =>
              setFilters({ ...filters, assignee: e.target.value })
            }
          >
            <option value="all">All Assignees</option>
            {assignees.map((name, idx) => (
              <option key={idx} value={name}>
                {formatText(name)}
              </option>
            ))}
          </select>:<></>}
          {workflows.length !==0 ?
          <select
            className="border rounded-lg px-3 py-1 text-sm"
            value={filters.workflowName}
            onChange={(e) =>
              setFilters({ ...filters, workflowName: e.target.value })
            }
          >
            <option value="all">All Workflows</option>
            {workflows.map((name, idx) => (
              <option key={idx} value={name}>
                {formatText(name)}
              </option>
            ))}
          </select>:<></>}

          <select
            className="border rounded-lg px-3 py-1 text-sm"
            value={filters.priority}
            onChange={(e) =>
              setFilters({ ...filters, priority: e.target.value })
            }
          >
            <option value="all">All Priorities</option>
            {priorities.map((p, idx) => (
              <option key={idx} value={p}>
                {formatText(p)}
              </option>
            ))}
          </select>

          <select
            className="border rounded-lg px-3 py-1 text-sm"
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          >
            <option value="all">All Status</option>
            {statuses.map((s, idx) => (
              <option key={idx} value={s}>
                {formatText(s)}
              </option>
            ))}
          </select>
<div className="relative">
  <SearchBar
    onQueryChange={handleSearchApi} 
    placeholder="Search Tasks..."
  />
</div>
          <div className="flex items-end justify-end">
            <button
                type="button"
                onClick={() => setFilters({
                  workflowName: "all",
                  assignee: "all",
                  priority: "all",
                  status: "all",
                })}
                className="bg-primary py-1 px-2 rounded-md text-sm font-medium text-white hover:bg-primary [&:active_span]:animate-spin-once"
            >
                <span className="inline-block">
                                   <RefreshCcw size={18} />
                                 </span>
            </button>
          </div>
        </div> : <></>}
        <div className="py-2 mt-1">
          {filteredTasks?.length !== 0 ? (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200 text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-2 py-1 text-left text-slate-700">#</th>
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("title")}><span className="flex flex-row items-center gap-1">Task <SortIcon column="title" /></span></th>
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("assignedToName")}><span className="flex flex-row items-center gap-1">Assignee <SortIcon column="assignedToName" /></span></th>
                    {type === "workflow" ?
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("workflowName")}><span className="flex flex-row items-center gap-1">Workflow <SortIcon column="workflowName" /></span></th>:<></>}
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("priority")}><span className="flex flex-row items-center gap-1">Priority <SortIcon column="priority" /></span></th>
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("status")}><span className="flex flex-row items-center gap-1">Status <SortIcon column="status" /></span></th>
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("dueDate")}><span className="flex flex-row items-center gap-1">Due Date <SortIcon column="dueDate" /></span></th>
                    <th className="px-2 py-1 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {sortedTasks.map((task, index) => (
                    <tr key={task?.id} className="hover:bg-gray-50">
                      <td className="px-2 py-1">{index + 1}</td>
                      <td className="px-2 py-1 font-medium">{task.title}</td>
                      {/* {type === "task" ? */}
                      <td className="px-2 py-1">{task?.assignedToName}</td>
                      {type === "workflow" ?
                      <td className="px-2 py-1">{formatText(task?.workflowName)}</td>:<></>}
                      <td className="px-2 py-1">
                        <span
                          className={`px-2 py-0.5 text-xs rounded-full ${getPriorityColor(
                            task.priority
                          )}`}
                        >
                          {formatText(task.priority)}
                        </span>
                      </td>
                      <td className="px-2 py-1">
                        <span
                          className={`px-2 py-0.5 text-xs rounded-full ${getStatusColor(
                            task.status
                          )}`}
                        >
                          {formatText(task.status)}
                        </span>
                      </td>
                      <td className="px-2 py-1">{task.dueDate}
                        {task.dueDate && (
                            <span
                              className={`text-[9px] ${
                                isOverdue(task.dueDate, task?.status)
                                  ? "text-red-500 font-medium"
                                  : "text-gray-500"
                              }`}
                            >
                              {isOverdue(task.dueDate, task?.status) &&
                                " (Overdue)"}
                            </span>
                          )}
                      </td>
                      <td className="px-2 py-1 text-center">
                        {/* {type === "workflow" ?
                          <button
                            onClick={() => setViewTask(task)}
                            className="text-blue-600 hover:text-blue-900"
                          >
                            <Eye className="h-4 w-4" />
                          </button>:<></>} */}
                          <button
                            onClick={() => {setTaskId(task?.id); 
                              setFormData({
                                title: task.title || "",
                                description: task.description || "",
                                startDate: task.startDate || "",
                                dueDate: task.dueDate || "",
                                priority: task.priority || "",
                                status: task.status || "TODO",
                                account: task.accountId || "",
                                workflowId: task.workflowName ? workflowDropdown.find( (item) => item.label === task.workflowName )?.value : "",
                                assignedTo: task?.assignedToId || "",
                              });
                            setAttachments(task?.attachments);
                            setComments(task?.comments.length !==0 ? task?.comments : [{ content: "" }]);
                          }}
                            className="text-blue-600 hover:text-blue-900"
                          >
                            <Edit className="h-4 w-4" />
                          </button>
                          <button
                            onClick={() => {
                              if (type === "workflow") {
                                handleDeleteTask(task);
                              }else{
                                handleDeleteTask(task?.id);
                              }
                            }}
                            className="p-1 text-red-600 hover:text-red-800"
                            title="Delete"
                          >
                            <Trash2 size={14} />
                          </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center">
              <Clock className="h-12 w-12 text-gray-400 mx-auto mb-1" />
              <h4 className="text-lg font-medium text-gray-900 mb-1">No Tasks</h4>
              <p className="text-gray-600 mb-4">
                No tasks have been assigned for this {heading} yet.
              </p>
            </div>
          )}
        </div>
      </div>}


      {showCreateTask && 
        <AddTasksAll
          type={type}
          errors={errors}
          workflowDropdown={workflowDropdown}
          onRefreshAccounts={onRefreshAccounts}
          onClose={() => setShowCreateTask(false)}
          setShowCreateTask={setShowCreateTask}
          formData={formData}
          setFormData={setFormData}
          handleSubmit={handleSubmit}
          isLoader={isLoader}
          attachments={attachments}
          setAttachments={setAttachments}
          comments={comments}
          setComments={setComments}
        />}

      {taskId && 
        <AddTasksAll
          type={type}
          errors={errors}
          onClose={() => setTaskId(null)}
          setShowCreateTask={setTaskId}
          workflowDropdown={workflowDropdown}
          onRefreshAccounts={onRefreshAccounts}
          formData={formData}
          setFormData={setFormData}
          handleSubmit={handleSubmit}
          isLoader={isLoader}
          taskId={taskId}
          attachments={attachments}
          setAttachments={setAttachments}
          comments={comments}
          setComments={setComments}
        />
      }

      {viewTask && (
        <div onClick={() => setViewTask(null)} className="fixed inset-0 -top-6 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div onClick={(e)=> e.stopPropagation()} className="bg-white rounded-lg shadow-2xl max-w-2xl w-full">
            <div className="flex justify-between items-center px-2 py-1 border-b">
              <div className="text-lg font-semibold text-gray-900">
                Task Details
              </div>
              <button
                onClick={() => setViewTask(null)}
                className="p-1 rounded-md bg-red-50 text-red-700 hover:bg-red-100 transition"
              >
                <X size={20} />
              </button>
            </div>

            <div className="relative p-3 text-sm bg-white rounded-xl shadow-md">
              <div className="mb-2">
                <h3 className="text-lg font-semibold text-gray-900 leading-tight">
                  {viewTask.title}
                </h3>
                <p className="text-xs text-gray-400 mt-0">
                  Task Overview
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="bg-gray-50 rounded-lg p-2">
                  <p className="text-xs text-gray-400 mb-0">
                    {viewTask?.assignedTo?.fullName ? "Assignee" : "Workflow"}
                  </p>
                  <p className="font-medium text-gray-800">
                    {viewTask?.assignedTo?.fullName
                      || formatText(viewTask?.workflowName)}
                  </p>
                </div>
                <div className="bg-gray-50 rounded-lg p-2">
                  <p className="text-xs text-gray-400 mb-0">Due Date</p>
                  <p className="font-medium text-gray-800">
                    {viewTask.dueDate || "N/A"}
                  </p>
                </div>
                <div className="bg-gray-50 rounded-lg p-2">
                  <p className="text-xs text-gray-400 mb-0">Priority</p>
                  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold
                    ${viewTask.priority === "HIGH"
                      ? "bg-red-100 text-red-600"
                      : viewTask.priority === "MEDIUM"
                      ? "bg-yellow-100 text-yellow-700"
                      : "bg-green-100 text-green-600"}
                  `}>
                    {formatText(viewTask.priority)}
                  </span>
                </div>
                <div className="bg-gray-50 rounded-lg p-2">
                  <p className="text-xs text-gray-400 mb-0">Status</p>
                  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold
                    ${viewTask.status === "Completed"
                      ? "bg-green-100 text-green-600"
                      : viewTask.status === "In Progress"
                      ? "bg-blue-100 text-blue-600"
                      : "bg-gray-100 text-gray-600"}
                  `}>
                    {formatText(viewTask.status)}
                  </span>
                </div>
              </div>
              {viewTask.description && (
                <div className="mt-2 border-t pt-2">
                  <p className="text-xs text-gray-400 mb-2">Description</p>
                  <div className="bg-gray-50 rounded-lg px-3 py-2 text-gray-700 leading-relaxed">
                    {viewTask.description}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TasksTabAll;
